import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild
} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import {
  AirportListLookupModel,
  AirportLookupModel,
  CountryListLookupModel,
  DefaultProvincesLookupModel
} from '../../model/airport-lookup.model';
import { ContentAirportLookup } from '../../model/content/contentAirportLookup.model';
import { AirportLookupService } from '../../services/airport-lookup-service/airport-lookup.service';
import { AirportLookupDirective } from '../airport-lookup/airport-lookup.directive';

declare let delta: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'full-airport-list',
  templateUrl: 'full-airport-list.component.html'
})
export class FullAirportListComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('dialog') dialog: any;
  isClosed: boolean;
  isModalShown = false;
  isselectedCountry = false;
  isselectedProviences = false;
  selectedCountry: any;
  selectedCountryName: any;
  selectedProviences: any;
  selectedAlphabetically: any;
  airportSelected: any;
  countrylistnavItem: string;
  countrylistnavLink: any;
  airportLookupDir: AirportLookupDirective;
  sortOrder: { name: string; descending: boolean } = {
    name: 'countryName',
    descending: false
  };

  modalConfig = {
    animated: false
  };

  defaultProvincesList: DefaultProvincesLookupModel[] = [];
  countryList: CountryListLookupModel[] = [];
  airportListCountryWise: AirportListLookupModel[] = [];
  airportListProviencesWise: AirportListLookupModel[] = [];
  airportListalphAbeticallyWise: AirportListLookupModel[] = [];
  airportLookupContent: ContentAirportLookup;
  public timeouts = [];

  constructor(
    public bsModalRef: BsModalRef,
    private airportLookupService: AirportLookupService,
    private el: ElementRef,
    private ren: Renderer2
  ) {}

  ngOnInit() {
    this.isClosed = false;
    this.defaultProvincesList =
      this.airportLookupService.getDefaultProviences('US,CA');
  }

  ngAfterViewInit() {
    const fullAirportListContent = document.body.querySelector(
      '.modal .modal-content .country-list-modal'
    );
    this.setFocus(fullAirportListContent);
    this.countrylistnavItem = this.el.nativeElement.querySelectorAll(
      '.country-list-body .nav-tabs li'
    );
    for (let i = 0; i < this.countrylistnavItem.length; i++) {
      this.ren.setAttribute(this.countrylistnavItem[i], 'role', 'none');
    }
    this.countrylistnavLink = this.el.nativeElement.querySelectorAll(
      '.country-list-body .nav-tabs li a'
    );
    for (let j = 0; j < this.countrylistnavLink.length; j++) {
      const tab = this.countrylistnavLink[j];
      this.ren.setAttribute(tab, 'role', 'tab');
      this.ren.setAttribute(
        tab,
        'aria-selected',
        tab.classList.contains('active')
      );
    }
  }

  selectedAirport(item) {
    this.airportSelected = item;
    if (this.airportLookupDir) {
      this.airportLookupDir.close();
      this.airportLookupDir.selectAirport(
        new AirportLookupModel(
          item.airportCode,
          item.cityName,
          item.region,
          item.countryCode,
          item.airportName
        )
      );
      this.bsModalRef.hide();
    }
  }

  close() {
    if (this.airportLookupDir) {
      this.airportLookupDir.close();
    }

    this.bsModalRef.hide();
    this.isClosed = true;
    document.getElementsByTagName('html')[0].classList.remove('no-scroll');
    this.closePopoupFocus();
  }

  closePopoupFocus() {
    if (this.isClosed != null && this.isClosed) {
      const afterCloseFocusElement =
        this.bsModalRef.content.airportLookupDir.el.nativeElement;
      afterCloseFocusElement.focus();
    }
  }

  back() {
    this.isselectedCountry = false;
    this.isselectedProviences = false;
  }

  select(item, tabValue: string) {
    if (tabValue === 'country') {
      this.selectedCountry = item;
      this.selectedCountryName = this.selectedCountry.countryName;
      this.isselectedCountry = true;
      this.airportListCountryWise = this.airportLookupService.getAirportList(
        item.countryCode,
        '',
        'country'
      );
    } else if (tabValue === 'proviences') {
      this.selectedProviences = item;
      this.selectedCountryName = this.selectedProviences.stateProvinceName;
      this.isselectedProviences = true;
      this.airportListProviencesWise = this.airportLookupService.getAirportList(
        item.countryCode,
        item.stateProvinceCode,
        'proviences'
      );
    }
  }

  tabSelected(tabValue: string, event: any) {
    if (tabValue === 'country') {
      this.countryList = this.airportLookupService.getCountryList();
    } else if (tabValue === 'alphabetically') {
      this.airportListalphAbeticallyWise =
        this.airportLookupService.getAirportList('ALL', '', 'alphabetically');
    } else if (tabValue === 'proviences') {
      this.defaultProvincesList =
        this.airportLookupService.getDefaultProviences('US,CA');
    }
    if (
      event.elementRef.nativeElement.innerText !== '' &&
      event.elementRef.nativeElement.innerText != null
    ) {
      this.handleSelectedTab(event);
    }
  }

  setFocus(element) {
    if (this.el.nativeElement.getElementsByClassName('country-list-modal')) {
      const elementToBeFocussed = this.el.nativeElement.children[0];
      this.timeouts.push(
        setTimeout(() => {
          elementToBeFocussed.focus();
        }, 200)
      );
    }
  }

  handleSelectedTab(evtSelectedTab: any) {
    if (evtSelectedTab !== undefined && evtSelectedTab !== null) {
      for (let i = 0; i < this.countrylistnavLink?.length; i++) {
        const tab = this.countrylistnavLink[i];
        if (
          evtSelectedTab.heading !== undefined &&
          evtSelectedTab.heading !== null &&
          evtSelectedTab.heading.toUpperCase() === tab.innerText.toUpperCase()
        ) {
          this.ren.setAttribute(tab, 'aria-selected', 'true');
        } else {
          this.ren.setAttribute(tab, 'aria-selected', 'false');
        }
      }
    }
  }

  stopTimeout() {
    for (let i = 0; i < this.timeouts.length; i++) {
      clearTimeout(this.timeouts[i]);
    }
    this.timeouts = [];
  }

  ngOnDestroy() {
    this.stopTimeout();
  }
}
